import { Component, OnInit } from '@angular/core';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { HandlerService } from '../handler.service';
import { ApiService } from '../api.service';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-policy',
  templateUrl: './policy.component.html',
  styleUrls: ['./policy.component.scss'],
})
export class PolicyComponent  {

  about1 : boolean;
  terms: boolean;
 privacy : boolean;
 refund:boolean;
 loader: boolean = false;
 
  constructor(private socialSharing: SocialSharing, public handler: HandlerService, private platform: Platform,
    public service: ApiService) { }

   
    mobShare() {
      if (this.platform.ANDROID || this.platform.IOS) {
       var link = "hello";
        this.socialSharing.share(link , null,null)
          .then(() => { return null; })
          .catch(() => { return null })
      }
    } 

  termsOfUse(){
    this.terms=true;
  }
  privacyPolicy(){
    this.privacy=true;
  }
  about(){
    this.about1=true;
  }
  getRefundPolicy(){
    this.refund=true;  }


}
